<button
	mat-raised-button
	[style.height.px]="height + shadowHeight"
	[style.border-radius.px]="radius"
	[color]="color"
	(click)="buttonClicked($event)"
	[disabled]="disabled"
>
	<div class="inner" [ngClass]="color" [style.border-radius.px]="radius">
		<div class="busy" *ngIf="busy">
			<mat-spinner
				color="spinnerColor"
				[diameter]="27"
				[strokeWidth]="4"
			></mat-spinner>
		</div>
		<div
			class="content"
			[style.padding-left.px]="contentPadding"
			[style.padding-right.px]="contentPadding"
			*ngIf="!busy"
		>
			<img [src]="iconImage" *ngIf="iconImage && !after" />
			<ng-content></ng-content>
			<img class="after" [src]="iconImage" *ngIf="iconImage && after" />
		</div>
	</div>
</button>
